import styled from 'styled-components';

import { linkStyles } from '@components/blocks/blocks.styles';
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';
import { FONT_STYLE } from '@theme/font';

import { containerStyles, textStyles } from '../pdp.styles';

export const Container = styled.div`
  ${containerStyles};

  ${media.desktop} {
    grid-template-columns: 23% auto calc(24% - 200px);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${media.desktop} {
    flex-direction: row;
  }
`;

export const Title = styled.h4`
  ${textStyles};
  margin: 0 ${OFFSET.M} 0 0;
  text-align: left;
  text-transform: none;
  font-style: ${FONT_STYLE.ITALIC};
  hyphens: auto;

  ${media.desktop} {
    min-width: 100px;
    max-width: 260px;
  }
`;

export const LongDescription = styled.div`
  margin: 0 0 ${OFFSET.S};
  ${textStyles};

  > * {
    margin-top: 0;
    padding-top: 0;
  }

  a {
    ${linkStyles};
  }
`;
